<template>
  <!-- class="lg:flex flex-1" -->
  <!-- AI 검색 페이지 - 경로가 '/mall/ai-search'인 경우 -->
  <aiSearchPage v-if="$route.path === '/mall/ai-search'" />

  <!-- AI 검색 결과 페이지 - 경로가 '/mall/ai-result'인 경우 -->
  <div v-if="$route.path === '/mall/ai-result'">
    <TNavComponent />
    <toTopComponent />

    <div class="w-full max-lg:py-14 py-20 mt-5">
      <aiSearchResultPage />
    </div>
    <FooterComponent />
  </div>
</template>

<script>
import TNavComponent from "@/components/new/Nav.vue";
import toTopComponent from "@/components/toTopComponent.vue";
import aiSearchPage from "@/pages/contentsMall/aiSearchPage.vue";
import aiSearchResultPage from "@/pages/contentsMall/aiSearchResultPage.vue";
import FooterComponent from "@/components/FooterComponent.vue";

export default {
  name: "contentsDetail",
  components: {
    aiSearchPage,
    aiSearchResultPage,
    TNavComponent,
    toTopComponent,
    FooterComponent,
  },
};
</script>
